/**
 * Callable request/response contracts: names. Split out of the one big callables.ts (Oct 2026) so a session opens
 * only the tool it works on; the contracts themselves are unchanged. Import as before, from '@daaily/shared' (or
 * './callables.js' inside shared); the barrel re-exports every file in this folder. The function NAMES stay in
 * callables/names.ts (`CALLABLES`).
 */
export const CALLABLES = {
    PING: 'ping',
    ADMIN_UPDATE_USER: 'adminUpdateUser',
    ADMIN_BULK_IMPORT_USERS: 'adminBulkImportUsers',
    ADMIN_UPDATE_COUNTRY: 'adminUpdateCountry',
    ADMIN_BULK_IMPORT_COUNTRIES: 'adminBulkImportCountries',
    ADMIN_CREATE_RESOURCE: 'adminCreateResource',
    ADMIN_UPDATE_RESOURCE: 'adminUpdateResource',
    ADMIN_DELETE_RESOURCE: 'adminDeleteResource',
    RESOURCE_DOWNLOAD: 'resourceDownload',
    ADMIN_TRIGGER_PAYROLL_SUMMARY: 'adminTriggerPayrollSummary',
    ADMIN_TRIGGER_CH_PAYROLL_SUMMARY: 'adminTriggerChPayrollSummary',
    ADMIN_SEND_CH_PAYROLL_SUMMARY: 'adminSendChPayrollSummary',
    ADMIN_RESTORE_RECEIPTS_FROM_DRIVE: 'adminRestoreReceiptsFromDrive',
    RECEIPT_PREVIEW_URL: 'receiptPreviewUrl',
    ADMIN_REPLACE_RECEIPT: 'adminReplaceReceipt',
    HUB_REQUEST_ACCESS: 'hubRequestAccess',
    STATEMENT_CREATE: 'statementCreate',
    STATEMENT_SUBMIT: 'statementSubmit',
    STATEMENT_RECALL: 'statementRecall',
    STATEMENT_FORWARD: 'statementForward',
    STATEMENT_APPROVE: 'statementApprove',
    STATEMENT_REJECT: 'statementReject',
    STATEMENT_REASSIGN: 'statementReassign',
    STATEMENT_MANUAL_FX: 'statementManualFx',
    STATEMENT_COMMENT: 'statementComment',
    STATEMENT_DOWNLOAD_PDF: 'statementDownloadPdf',
    STATEMENT_META_EDIT: 'statementMetaEdit',
    EXPENSE_LINE_ITEM_ADD: 'expenseLineItemAdd',
    EXPENSE_LINE_ITEM_EDIT: 'expenseLineItemEdit',
    TRAVEL_ALLOWANCE_ADD: 'travelAllowanceAdd',
    TRAVEL_ALLOWANCE_EDIT: 'travelAllowanceEdit',
    LINE_ITEM_DELETE: 'lineItemDelete',
    INVOICE_UPSERT_DRAFT: 'invoiceUpsertDraft',
    INVOICE_PARSE_PDF: 'invoiceParsePdf',
    // Hub Guide (Sep 2026): Gemini answers grounded in shared/guide docs.
    GUIDE_ASK: 'guideAsk',
    FTE_REPORT_PREVIEW: 'fteReportPreview',
    FTE_REPORT_SEND_NOW: 'fteReportSendNow',
    FTE_KOSTENSTELLE_SNAPSHOT_SET: 'fteKostenstelleSnapshotSet',
    VACATION_SUMMARY_PREVIEW: 'vacationSummaryPreview',
    VACATION_SUMMARY_SEND_NOW: 'vacationSummarySendNow',
    TIME_SUMMARY_ROWS: 'timeSummaryRows',
    TIME_SUMMARY_PREVIEW: 'timeSummaryPreview',
    TIME_SUMMARY_SEND_NOW: 'timeSummarySendNow',
    VACATION_STATUS_SEND_NOW: 'vacationStatusSendNow',
    DOCUMENT_CATEGORY_ADD: 'documentCategoryAdd',
    DOCUMENT_CATEGORY_RENAME: 'documentCategoryRename',
    DOCUMENT_CATEGORY_DELETE: 'documentCategoryDelete',
    CONFIG_REQUEST_FOLDER_CHANGE: 'configRequestFolderChange',
    CONFIG_APPROVE_FOLDER_CHANGE: 'configApproveFolderChange',
    CONFIG_REJECT_FOLDER_CHANGE: 'configRejectFolderChange',
    INVOICE_ATTACH_RECEIPT: 'invoiceAttachReceipt',
    INVOICE_SUBMIT: 'invoiceSubmit',
    INVOICE_WITHDRAW: 'invoiceWithdraw',
    ADMIN_LIST_INVOICE_APPROVERS: 'adminListInvoiceApprovers',
    INVOICE_APPROVE: 'invoiceApprove',
    INVOICE_REJECT: 'invoiceReject',
    INVOICE_RESUBMIT: 'invoiceResubmit',
    INVOICE_RECEIPT_URL: 'invoiceReceiptUrl',
    CREDIT_CARD_PARSE_STATEMENT: 'creditCardParseStatement',
    CREDIT_CARD_UPDATE_LINE_ITEM: 'creditCardUpdateLineItem',
    CREDIT_CARD_SET_RECEIPT: 'creditCardSetReceipt',
    CREDIT_CARD_SUBMIT: 'creditCardSubmit',
    CREDIT_CARD_APPROVE: 'creditCardApprove',
    CREDIT_CARD_REJECT: 'creditCardReject',
    CREDIT_CARD_RECALL: 'creditCardRecall',
    CREDIT_CARD_DELETE: 'creditCardDelete',
    CREDIT_CARD_ATTACH_FROM_LIBRARY: 'creditCardAttachFromLibrary',
    CREDIT_CARD_ASSIGN: 'creditCardAssign',
    CREDIT_CARD_FINAL_REMINDER: 'creditCardFinalReminder',
    CREDIT_CARD_LIST_ASSIGNEES: 'creditCardListAssignees',
    CREDIT_CARD_LIST_LIBRARY_TARGETS: 'creditCardListLibraryTargets',
    CREDIT_CARD_LIBRARY_UPLOAD_FOR: 'creditCardLibraryUploadFor',
    CREDIT_CARD_LIBRARY_PREDICT_MISSING: 'creditCardLibraryPredictMissing',
    ABSENCE_CREATE_REQUEST: 'absenceCreateRequest',
    ABSENCE_DECIDE: 'absenceDecide',
    ABSENCE_CANCEL: 'absenceCancel',
    ABSENCE_HR_OVERRIDE: 'absenceHrOverride',
    ABSENCE_CARRY_OVER_SET: 'absenceCarryOverSet',
    ABSENCE_RECOUNT_WORKING_DAYS: 'absenceRecountWorkingDays',
    ABSENCE_TEAM_CALENDAR: 'absenceTeamCalendar',
    ABSENCE_MEMBER_OVERVIEW: 'absenceMemberOverview',
    ABSENCE_SICK_CERT_UPLOAD: 'absenceSickCertUpload',
    CONTENT_SOURCE_START: 'contentSourceStart',
    CONTENT_SOURCE_STOP: 'contentSourceStop',
    CONTENT_SOURCE_DELETE: 'contentSourceDelete',
    CONTENT_PROPOSAL_GENERATE: 'contentProposalGenerate',
    CONTENT_PROPOSAL_SAVE: 'contentProposalSave',
    CONTENT_PROPOSAL_EXPORT: 'contentProposalExport',
    CONTENT_SOURCE_CLIENT_MODE: 'contentSourceClientMode',
    CONTENT_ARCHDAILY_LOOKUP: 'contentArchdailyLookup',
    CONTENT_ARCHDAILY_SYNC: 'contentArchdailySync',
    CONTENT_CATALOG_INFO_CHECK: 'contentCatalogInfoCheck',
    CONTENT_ITEM_REGROUP: 'contentItemRegroup',
    CONTENT_SOURCE_CONTINUE: 'contentSourceContinue',
    EXPENSE_TEAM_STATEMENTS: 'expenseTeamStatements',
    EXPENSE_TEAM_STATEMENT_DETAIL: 'expenseTeamStatementDetail',
    EXPENSE_TEAM_EXPORT: 'expenseTeamExport',
    PAYPAL_IPN_SYNC_NOW: 'paypalIpnSyncNow',
    PAYPAL_IPN_MARK_INVOICED: 'paypalIpnMarkInvoiced',
    PAYPAL_IPN_CONFIRM_ACCOUNT: 'paypalIpnConfirmAccount',
    PAYPAL_IPN_CREATE_ACCOUNT: 'paypalIpnCreateAccount',
    PAYPAL_IPN_CREATE_ORDER: 'paypalIpnCreateOrder',
    OUTREACH_TEMPLATE_SAVE: 'outreachTemplateSave',
    OUTREACH_TEMPLATE_DELETE: 'outreachTemplateDelete',
    OUTREACH_SEND: 'outreachSend',
    OUTREACH_SFDC_SEARCH: 'outreachSfdcSearch',
    OUTREACH_PREFS_SET: 'outreachPrefsSet',
    OUTREACH_DNT_SET: 'outreachDoNotTrackSet',
    OUTREACH_CAMPAIGN_SAVE: 'outreachCampaignSave',
    OUTREACH_CAMPAIGN_ENROL: 'outreachCampaignEnrol',
    OUTREACH_CAMPAIGN_ACTION: 'outreachCampaignAction',
    OUTREACH_RECIPIENT_ACTION: 'outreachRecipientAction',
    BUSINESS_CARD_SAVE: 'businessCardSave',
    HUB_USAGE_PING: 'hubUsagePing',
    HUB_USAGE_ENGAGEMENT: 'hubUsageEngagement',
    HUB_USAGE_SUMMARY: 'hubUsageSummary',
    BUSINESS_CARD_LEAD_TO_SFDC: 'businessCardLeadToSfdc',
    DIRECTORS_GET_STATE: 'directorsGetState',
    DIRECTORS_SAVE_TOPIC: 'directorsSaveTopic',
    DIRECTORS_UPDATE_TOPIC: 'directorsUpdateTopic',
    DIRECTORS_MY_INPUTS: 'directorsMyInputs',
    DIRECTORS_CARRY_TOPIC: 'directorsCarryTopic',
    DIRECTORS_DELETE_TOPIC: 'directorsDeleteTopic',
    DIRECTORS_ADD_ATTACHMENT: 'directorsAddAttachment',
    DIRECTORS_SYNC_MEDIA: 'directorsSyncMedia',
    DIRECTORS_ATTACHMENT_URL: 'directorsAttachmentUrl',
    DIRECTORS_DELETE_ATTACHMENT: 'directorsDeleteAttachment',
    DIRECTORS_ADD_ACTION: 'directorsAddAction',
    DIRECTORS_SET_ACTION_DONE: 'directorsSetActionDone',
    DIRECTORS_IMPORT_NOTES: 'directorsImportNotes',
    DIRECTORS_CLOSE_MEETING: 'directorsCloseMeeting',
    DIRECTORS_SAVE_COMPANY_MEETING: 'directorsSaveCompanyMeeting',
    DIRECTORS_SAVE_COMPANY_ITEM: 'directorsSaveCompanyItem',
    DIRECTORS_DELETE_COMPANY_ITEM: 'directorsDeleteCompanyItem',
    DIRECTORS_REORDER_COMPANY_ITEMS: 'directorsReorderCompanyItems',
    DIRECTORS_CREATE_DECK: 'directorsCreateDeck',
    PAYPAL_IPN_STATEMENT_CONFIG_SET: 'paypalIpnStatementConfigSet',
    PAYPAL_IPN_STATEMENT_SEND: 'paypalIpnStatementSend',
    PAYPAL_IPN_PRODUCT_NAMES_SET: 'paypalIpnProductNamesSet',
    PAYPAL_IPN_CREATE_INVOICE: 'paypalIpnCreateInvoice',
    PAYPAL_IPN_INVOICE_URL: 'paypalIpnInvoiceUrl',
    PAYPAL_IPN_INVOICE_PREVIEW: 'paypalIpnInvoicePreview',
    PAYPAL_REVENUE_GOALS_SET: 'paypalRevenueGoalsSet',
    ABSENCE_PENDING_APPROVALS: 'absencePendingApprovals',
    ADMIN_SET_USER_PHOTO: 'adminSetUserPhoto',
    ADMIN_SET_USER_ACTIVE: 'adminSetUserActive',
    ADMIN_IMPERSONATE: 'adminImpersonate',
    ADMIN_SEND_TEST_EMAIL: 'adminSendTestEmail',
    ADMIN_EMAIL_PREVIEWS: 'adminEmailPreviews',
    HUB_VERSION: 'hubVersion',
    CREDIT_CARD_PREVIEW_PDF: 'creditCardPreviewPdf',
    CREDIT_CARD_SOURCE_PDF_URL: 'creditCardSourcePdfUrl',
    CREDIT_CARD_LIST_PEOPLE: 'creditCardListPeople',
    CREDIT_CARD_REQUEST_RECEIPT: 'creditCardRequestReceipt',
    CREDIT_CARD_REQUEST_RECEIPT_BULK: 'creditCardRequestReceiptBulk',
    CREDIT_CARD_FULFILL_RECEIPT_REQUEST: 'creditCardFulfillReceiptRequest',
    CREDIT_CARD_DECLINE_RECEIPT_REQUEST: 'creditCardDeclineReceiptRequest',
    CREDIT_CARD_CANCEL_RECEIPT_REQUEST: 'creditCardCancelReceiptRequest',
    SUBMIT_FEEDBACK: 'submitFeedback',
    FEEDBACK_DECIDE: 'feedbackDecide',
    FEEDBACK_ACKNOWLEDGE_ALL: 'feedbackAcknowledgeAll',
    FEEDBACK_SCREENSHOT_URL: 'feedbackScreenshotUrl',
    FEEDBACK_GENERATE_SUMMARY: 'feedbackGenerateSummary',
    DISMISS_ANNOUNCEMENT: 'dismissAnnouncement',
    HUB_ACKNOWLEDGE_TODO: 'hubAcknowledgeTodo',
    ANNOUNCEMENT_SAVE: 'announcementSave',
    ANNOUNCEMENT_DELETE: 'announcementDelete',
    ANNOUNCEMENTS_FOR_ME: 'announcementsForMe',
    REMOTE_SYNC_NOW: 'remoteSyncNow',
    REMOTE_IMPORT_DOCUMENTS: 'remoteImportDocuments',
    REMOTE_EXPENSES_OVERVIEW: 'remoteExpensesOverview',
    SELF_UPDATE_PROFILE: 'selfUpdateProfile',
    PROFILE_ONBOARDING_MARK: 'profileOnboardingMark',
    PUSH_REGISTER: 'pushRegister',
    PUSH_UNREGISTER: 'pushUnregister',
    PUSH_TEST: 'pushTest',
    REQUEST_PRIVATE_EMAIL_CHANGE: 'requestPrivateEmailChange',
    VERIFY_PRIVATE_EMAIL_TOKEN: 'verifyPrivateEmailToken',
    // Pay (compensation) — see shared/src/pay.ts
    ADMIN_GET_PAY_RATES: 'adminGetPayRates',
    ADMIN_SAVE_PAY_RATES: 'adminSavePayRates',
    ADMIN_SET_PAY_CONTROLS: 'adminSetPayControls',
    ADMIN_RESET_PAY_VIEW_PASSWORD: 'adminResetPayViewPassword',
    SET_PAY_VIEW_PASSWORD: 'setPayViewPassword',
    REVEAL_TEAM_MEMBER_PAY: 'revealTeamMemberPay',
    // Performance Reviews — authoring (admin)
    REVIEW_LIST_CATEGORIES: 'reviewListCategories',
    REVIEW_UPSERT_CATEGORY: 'reviewUpsertCategory',
    REVIEW_LIST_QUESTIONS: 'reviewListQuestions',
    REVIEW_UPSERT_QUESTION: 'reviewUpsertQuestion',
    REVIEW_LIST_CYCLES: 'reviewListCycles',
    REVIEW_GET_CYCLE: 'reviewGetCycle',
    REVIEW_SAVE_CYCLE: 'reviewSaveCycle',
    REVIEW_CLONE_CYCLE: 'reviewCloneCycle',
    REVIEW_PUBLISH_CYCLE: 'reviewPublishCycle',
    REVIEW_CLOSE_CYCLE: 'reviewCloseCycle',
    REVIEW_DELETE_CYCLE: 'reviewDeleteCycle',
    REVIEW_LIST_SURVEYS: 'reviewListSurveys',
    REVIEW_SAVE_SURVEY: 'reviewSaveSurvey',
    REVIEW_DELETE_SURVEY: 'reviewDeleteSurvey',
    REVIEW_LIST_PARTICIPANTS: 'reviewListParticipants',
    REVIEW_SAVE_PARTICIPANTS: 'reviewSaveParticipants',
    REVIEW_SET_FILL_STATE: 'reviewSetFillState',
    REVIEW_SET_RESULT_STAGES: 'reviewSetResultStages',
    REVIEW_SET_PHASE: 'reviewSetPhase',
    REVIEW_RESYNC_SNAPSHOT: 'reviewResyncSnapshot',
    // Performance Reviews — fill flow
    REVIEW_MY_ASSIGNMENTS: 'reviewMyAssignments',
    REVIEW_GET_ASSIGNMENT: 'reviewGetAssignment',
    REVIEW_SAVE_DRAFT: 'reviewSaveDraft',
    REVIEW_SUBMIT: 'reviewSubmit',
    REVIEW_RELEASE: 'reviewRelease',
    // Performance Reviews — peer (manager assigns)
    REVIEW_LIST_PEOPLE: 'reviewListPeople',
    REVIEW_ASSIGN_PEERS: 'reviewAssignPeers',
    REVIEW_LIST_PEER_ASSIGNMENTS: 'reviewListPeerAssignments',
    REVIEW_REMOVE_PEER: 'reviewRemovePeer',
    REVIEW_NOMINATION_TASKS: 'reviewNominationTasks',
    REVIEW_MARK_GUIDANCE_SEEN: 'reviewMarkGuidanceSeen',
    REVIEW_SUBJECT_RECAP: 'reviewSubjectRecap',
    REVIEW_FEEDBACK_VOTE: 'reviewFeedbackVote',
    REVIEW_FEEDBACK_VOTE_STATS: 'reviewFeedbackVoteStats',
    REVIEW_NOMINATION_GAPS: 'reviewNominationGaps',
    // Performance Reviews — analytics
    REVIEW_ANALYTICS: 'reviewAnalytics',
    REVIEW_SUBJECT_RESULTS: 'reviewSubjectResults',
    REVIEW_SUBJECT_TREND: 'reviewSubjectTrend',
    REVIEW_TEAM_BOARD: 'reviewTeamBoard',
    REVIEW_SUBJECT_RESULTS_PDF: 'reviewSubjectResultsPdf',
    REVIEW_SAVE_CONVERSATION: 'reviewSaveConversation',
    REVIEW_SET_CONVERSATION_HELD: 'reviewSetConversationHeld',
    REVIEW_ACKNOWLEDGE: 'reviewAcknowledge',
    REVIEW_SET_SHARE_MODE: 'reviewSetShareMode',
    ORG_PROFILE: 'orgProfile',
    ORG_CHART_PEOPLE: 'orgChartPeople',
    DOCUMENT_CREATE: 'documentCreate',
    DOCUMENT_CLASSIFY: 'documentClassify',
    DOCUMENT_DELETE: 'documentDelete',
    DOCUMENT_SET_VISIBILITY: 'documentSetVisibility',
    DOCUMENT_SET_CATEGORY: 'documentSetCategory',
    DOCUMENT_SET_PERIOD: 'documentSetPeriod',
    DOCUMENT_SUBMISSION_CREATE: 'documentSubmissionCreate',
    DOCUMENT_SUBMISSION_DECIDE: 'documentSubmissionDecide',
    DOCUMENT_SUBMISSION_URL: 'documentSubmissionUrl',
    DOCUMENT_DOWNLOAD_URL: 'documentDownloadUrl',
    COMPANY_DOCUMENT_CREATE: 'companyDocumentCreate',
    COMPANY_DOCUMENT_UPDATE: 'companyDocumentUpdate',
    COMPANY_DOCUMENT_DELETE: 'companyDocumentDelete',
    COMPANY_DOCUMENT_LIST: 'companyDocumentList',
    COMPANY_DOCUMENT_URL: 'companyDocumentUrl',
    TIME_CLOCK: 'timeClock',
    TIME_UPSERT_DAY: 'timeUpsertDay',
    TIME_SET_DEFAULT_HOURS: 'timeSetDefaultHours',
    TIME_SUBMIT_STATEMENT: 'timeSubmitStatement',
    TIME_DECIDE_STATEMENT: 'timeDecideStatement',
    TIME_RECALL_STATEMENT: 'timeRecallStatement',
    TIME_TEAM_OVERVIEW: 'timeTeamOverview',
    TIME_MEMBER_MONTH: 'timeMemberMonth',
    ADMIN_SET_TIME_TRACKING_CONFIG: 'adminSetTimeTrackingConfig',
    ADMIN_ASSIGN_ABSENCE_POLICY: 'adminAssignAbsencePolicy',
    ADMIN_ASSIGN_HR_POLICY: 'adminAssignHrPolicy',
    ABSENCE_RECORD_HR_POLICY: 'absenceRecordHrPolicy',
    // Onboarding checklists
    ONBOARDING_CREATE: 'onboardingCreate',
    ONBOARDING_GET: 'onboardingGet',
    ONBOARDING_LIST: 'onboardingList',
    ONBOARDING_MINE: 'onboardingMine',
    ONBOARDING_UPDATE_HEADER: 'onboardingUpdateHeader',
    ONBOARDING_SET_TASK: 'onboardingSetTask',
    ONBOARDING_ADD_TASK: 'onboardingAddTask',
    ONBOARDING_DELETE_TASK: 'onboardingDeleteTask',
    ONBOARDING_SET_STATUS: 'onboardingSetStatus',
    ONBOARDING_DELETE: 'onboardingDelete',
    ONBOARDING_SYNC_TEMPLATE: 'onboardingSyncTemplate',
    // DAAily Drivers (peer recognition)
    DRIVERS_LIST_PEOPLE: 'driversListPeople',
    DRIVERS_NOMINATE: 'driversNominate',
    DRIVERS_MY_RECEIVED: 'driversMyReceived',
    DRIVERS_MY_GIVEN: 'driversMyGiven',
    DRIVERS_MY_CABINET: 'driversMyCabinet',
    DRIVERS_ADMIN_LIST_MONTHS: 'driversAdminListMonths',
    DRIVERS_ADMIN_GET_MONTH: 'driversAdminGetMonth',
    DRIVERS_SET_WINNER: 'driversSetWinner',
    DRIVERS_RELEASE: 'driversRelease',
    DRIVERS_ANNUAL_EXPORT: 'driversAnnualExport',
    DRIVERS_TEAM_OVERVIEW: 'driversTeamOverview',
    DRIVERS_ORG_SUMMARY: 'driversOrgSummary',
    // Home: Moments (winners + claps, anniversaries, joiners) + Drivers pulse
    HUB_MOMENTS: 'hubMoments',
    HUB_CLAP: 'hubClap',
    // Monthly Mutations (admin-only HR checklist)
    MUTATION_SAVE: 'mutationSave',
    MUTATION_SET_STATUS: 'mutationSetStatus',
    MUTATION_DELETE: 'mutationDelete',
    MUTATIONS_PDF_PREVIEW: 'mutationsPdfPreview',
    // Commissions
    COMMISSION_UPLOAD_SOURCE: 'commissionUploadSource',
    COMMISSION_COMPUTE_REPORT: 'commissionComputeReport',
    COMMISSION_GET_REPORT: 'commissionGetReport',
    COMMISSION_SAVE_PAID: 'commissionSavePaid',
    COMMISSION_MY_STATEMENT: 'commissionMyStatement',
    COMMISSION_STATEMENT_PDF: 'commissionStatementPdf',
    COMMISSION_FX_REFRESH: 'commissionFxRefresh',
    COMMISSION_CONFIRM_PAYOUT: 'commissionConfirmPayout',
    COMMISSION_RELEASE_STATEMENTS: 'commissionReleaseStatements',
    COMMISSION_MY_RELEASES: 'commissionMyReleases',
    COMMISSION_MY_RELEASE_URL: 'commissionMyReleaseUrl',
    COMMISSION_MY_TEAM: 'commissionMyTeam',
    COMMISSION_TEAM_RELEASE_URL: 'commissionTeamReleaseUrl',
    COMMISSION_ACCRUAL_GET: 'commissionAccrualGet',
    COMMISSION_ACCRUAL_EXTEND: 'commissionAccrualExtend',
    COMMISSION_ACCRUAL_PREVIEW: 'commissionAccrualPreview',
    COMMISSION_PAYOUT_PREVIEW: 'commissionPayoutPreview',
    COMMISSION_SEND_ACCRUAL: 'commissionSendAccrual',
    COMMISSION_SEND_ACCRUAL_TEST: 'commissionSendAccrualTest',
    COMMISSION_ACCRUAL_SEND_URL: 'commissionAccrualSendUrl',
    COMMISSION_PULL_FROM_SALESFORCE: 'commissionPullFromSalesforce',
    // Agents layer
    COMMISSION_AGENT_UPLOAD_SOURCE: 'commissionAgentUploadSource',
    COMMISSION_AGENT_PULL: 'commissionAgentPull',
    COMMISSION_AGENT_COMPUTE_REPORT: 'commissionAgentComputeReport',
    COMMISSION_AGENT_GET_REPORT: 'commissionAgentGetReport',
    COMMISSION_AGENT_SAVE_ADJUSTMENT: 'commissionAgentSaveAdjustment',
    COMMISSION_AGENT_ADJUST_REISSUE: 'commissionAgentAdjustReissue',
    COMMISSION_AGENT_CORRECTION_APPLY: 'commissionAgentCorrectionApply',
    COMMISSION_AGENT_CORRECTION_ISSUE: 'commissionAgentCorrectionIssue',
    COMMISSION_AGENT_SAVE_PAID: 'commissionAgentSavePaid',
    COMMISSION_AGENT_MY_STATEMENT: 'commissionAgentMyStatement',
    COMMISSION_AGENT_MY_YTD: 'commissionAgentMyYtd',
    COMMISSION_AGENT_MANAGER_ROWS: 'commissionAgentManagerRows',
    COMMISSION_AGENT_STATEMENT_PDF: 'commissionAgentStatementPdf',
    COMMISSION_AGENT_RELEASE: 'commissionAgentRelease',
    // Commissions — OTHER layer (person-specific bonus plans, quarterly)
    COMMISSION_OTHER_COMPUTE_REPORT: 'commissionOtherComputeReport',
    COMMISSION_OTHER_GET_REPORT: 'commissionOtherGetReport',
    COMMISSION_OTHER_SAVE_ADJUSTMENT: 'commissionOtherSaveAdjustment',
    COMMISSION_OTHER_STATEMENT_PDF: 'commissionOtherStatementPdf',
    COMMISSION_OTHER_RELEASE: 'commissionOtherRelease',
    COMMISSION_OTHER_MY_STATEMENTS: 'commissionOtherMyStatements',
    COMMISSION_MY_ACCESS: 'commissionMyAccess',
    COMMISSION_AGENT_LOCK_PAYOUT: 'commissionAgentLockPayout',
    COMMISSION_AGENT_PAYOUT_YEAR: 'commissionAgentPayoutYear',
    COMMISSION_AGENT_PAYOUT_SUMMARY_TEST: 'commissionAgentPayoutSummaryTest',
    COMMISSION_AGENT_SET_DELTA: 'commissionAgentSetDelta',
    USL_PULL: 'uslPull',
    USL_REFRESH: 'uslRefresh',
    USL_REFRESH_ALL: 'uslRefreshAll',
    USL_GET_DASHBOARD: 'uslGetDashboard',
    USL_SAVE_MANUAL: 'uslSaveManual',
    USL_SAVE_FORECAST: 'uslSaveForecast',
    USL_IMPORT_SHEETS: 'uslImportSheets',
    SUBSCRIPTION_UPLOAD_SOURCE: 'subscriptionUploadSource',
    SUBSCRIPTION_GET_DASHBOARD: 'subscriptionGetDashboard',
    ANALYTICS_DASHBOARD: 'analyticsDashboard',
    SUBSCRIPTION_REFRESH: 'subscriptionRefresh',
    SUBSCRIPTION_REFRESH_ALL: 'subscriptionRefreshAll',
    SUBSCRIPTION_HEALTH_REFRESH: 'subscriptionHealthRefresh',
    SUBSCRIPTION_HEALTH_GET: 'subscriptionHealthGet',
    SUBSCRIPTION_CHURN_LIST: 'subscriptionChurnList',
    SUBSCRIPTION_COMMENTARY_GENERATE: 'subscriptionCommentaryGenerate',
    SUBSCRIPTION_STATS_REFRESH: 'subscriptionStatsRefresh',
    SUBSCRIPTION_STATS_GET: 'subscriptionStatsGet',
    SUBSCRIPTION_PROMOTIONS_REFRESH: 'subscriptionPromotionsRefresh',
    SUBSCRIPTION_PROMOTIONS_GET: 'subscriptionPromotionsGet',
    SUBSCRIPTION_CONVERSION_REFRESH: 'subscriptionConversionRefresh',
    SUBSCRIPTION_CONVERSION_GET: 'subscriptionConversionGet',
    // Product Projects
    PROJECT_SAVE: 'projectSave',
    PROJECT_DELETE: 'projectDelete',
    PROJECT_SUBMIT_REQUEST: 'projectSubmitRequest',
    PROJECT_DECIDE_REQUEST: 'projectDecideRequest',
    PROJECT_REVIEW_SCOPE_CHANGE: 'projectReviewScopeChange',
    PROJECT_SET_LINK_TYPES: 'projectSetLinkTypes',
    ACTION_ITEM_SAVE: 'actionItemSave',
    ACTION_ITEM_SET_STATUS: 'actionItemSetStatus',
};
//# sourceMappingURL=names.js.map